import {
  FETCH_HANDOVER,
  FETCH_HANDOVER_SUCCESS,
  FETCH_HANDOVER_FAILURE,
} from "./constants";

export const fetchHandover = (payload) => ({
  type: FETCH_HANDOVER,
  payload,
});
export const fetchHandoverSuccess = (payload) => ({
  type: FETCH_HANDOVER_SUCCESS,
  payload,
});
export const fetchHandoverFailure = () => ({
  type: FETCH_HANDOVER_FAILURE,
});
